import { connect } from 'react-redux';
import { StatAction, UserAction, CollateralAction } from '../../actions';
import { bindActionCreators } from 'redux';
import Credit from './Credit';

const mapStateToProps = (state) => {
	return {
		state: state.stat,
		exchange: state.exchange ? state.exchange[0] : {},
		user: state.user,
		coin: state.coin,
		collateral: state.collateral,
		constant: state.constant,
	};
};

const mapDispatchToProps = (dispatch) => ({
	statActions: bindActionCreators(StatAction, dispatch),
	userActions: bindActionCreators(UserAction, dispatch),
	actions: bindActionCreators(CollateralAction, dispatch),
	updateCollateral: bindActionCreators(CollateralAction.updateCollateral, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(Credit);
